import { Box } from '@chakra-ui/react';

import { Condition } from 'Component/others';
import Tab from 'View/host-presence-content/section/tab';
import ReportContent from 'View/host-presence-content/section/report-content';
import ReportPresence from 'View/host-presence-content/section/report-presence';
import HostPresenceContentProvider, { useHostPresenceContentState } from 'View/host-presence-content/state';

import styles from './styles.module.css';

const HostPresenceContent = () => {
  const { state } = useHostPresenceContentState();
  return (
    <Box className={styles['host-presence-content__container']}>
      <Tab />
      <Box className={styles['host-presence-content__content']}>
        <Condition statement={state?.selectedTab === 'presence'} children={<ReportPresence />} />
        <Condition statement={state?.selectedTab === 'content'} children={<ReportContent />} />
      </Box>
    </Box>
  );
};

const HostPresenceContentContainer = () => <HostPresenceContentProvider children={<HostPresenceContent />} />;

export default HostPresenceContentContainer;
